export const UNPUBLISHED_FLOW_HISTORY = 'unpublished';
export const AUTO_SAVED_FLOW_HISTORY = 'auto-saved';
export const FAULTY_FLOW_HISTORY = 'faulty-flow';